import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Bookmark = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15 8.40002L11.1402 12.2894C10.9937 12.4369 10.7563 12.4369 10.6098 12.2894L9 10.6672M6 2.40002H18C19.1046 2.40002 20 3.29545 20 4.40002V15.4C20 16.0295 19.7036 16.6223 19.2 17L13.2 21.5C12.4889 22.0334 11.5111 22.0334 10.8 21.5L4.8 17C4.29639 16.6223 4 16.0295 4 15.4V4.40002C4 3.29545 4.89543 2.40002 6 2.40002Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round"
        })
    });
};
